/*
Create By POOM : 2023-10-30
*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Pathurl from "../Class/Pathurl.json";
import { Link } from "react-router-dom";

import {
  Class_ETC_Encrypt,
  Bind_Presets_Calendar,
  Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";

import Select from "react-select";
import ConfigETC from "../Class/ConfigETC.json";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import PaginationActions from "../PartialView/PaginationActions";
import { customStylesSelect } from "../Class/Class_Etc"
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';



function M_company() {

  //#region __ Declare __

  const liststatus = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: ConfigETC.SwitchButton_active_text },
    { value: "0", label: ConfigETC.SwitchButton_inactive_text },
  ];
  
  const dataPresets = Bind_Presets_Calendar();
  
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [configData, setConfigData] = useState([]);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  
  const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
  const [ ActAdd ] = useState(Class_ETC_Encrypt("Add"));

  const [isresult, setIsresult] = useState(false);
  const [txt_searchmaxstaff, settxt_searchmaxstaff] = useState("");
  const [ddl_searchstatus, setddl_searchstatus] = useState(null);

  const [listdata, setListdata] = useState([]);

  //#endregion

  //#region __ useEffect __
  
  useEffect(() => {
    let supportsystem = localStorage.getItem("supportsystem");
    if (supportsystem === "allowcom0") {
      GetConfig();
      if (isLoadedConfigData === true) {
        BindList(true , "" , "-1" , "" , "" , "-1" , function() {
          setIsLoadProgress(false);
        });
      }
    }
    else {
      window.location.replace("../" + Pathurl.no_permission);
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        document.getElementById("btn_Search").click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);


  //#endregion

  //#region __ Function __
  
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindList(isSearch, com_name , com_status , date_start , date_end , max_staff, _callback) {
    try {
      
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw = JSON.stringify({
        "com_name": com_name,
        "com_status": com_status,
        "date_start": date_start,
        "date_end": date_end,
        "max_staff": max_staff
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Company_GetList",
        requestOptions
      );

      const json = await response.json();
      setIsresult(true);
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (isSearch) {
            setPage(0);
          } else {
            if (rowsPerPage * (page + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPage);
              setPage(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListdata(json.data);
          if (_callback != null) {
              _callback();
          }
        } else {
          setPage(0);
          setListdata([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        // ถ้าสถานะส่งมาไม่ใช่ 1 เราจะถือว่า คนๆนี้ไม่มีสิทธิการใช้งานในหน้านี้เลย
        window.location.replace("../" + Pathurl.no_permission);
      }
    } catch {
      setPage(0);
      window.location.replace("../" + Pathurl.no_permission);
    }
  }

  //#endregion

  //#region __ Event __

  const handleChangetxtMaxStaff =(evt)=>{
    const financialGoal = (evt.target.validity.valid) ? evt.target.value : txt_searchmaxstaff;
    settxt_searchmaxstaff(financialGoal)
  }

  function onClickReset(){
    
    document.getElementById("txt_searchName").value = "";
    setddl_searchstatus(null);
    document.getElementById("txt_SearchDate").value = "";
    settxt_searchmaxstaff("");
    setIsresult(false);
  }

  function onClickSearch(){

    let txtname = document.getElementById("txt_searchName").value.trim();
    let ddlstatus = "-1";
    let txtdateS = "";
    let txtdateE = "";
    let txtmaxstaff = (txt_searchmaxstaff === "" ? "-1" : txt_searchmaxstaff);

    if (ddl_searchstatus !== null){
      ddlstatus = ddl_searchstatus.value;
    }

    let date_rang = document.getElementById("txt_SearchDate").value.trim();
    if (date_rang !== "")
    {
      let datevalue =  date_rang.split(" - ");
      if (datevalue.length === 2)
      {
        txtdateS = datevalue[0];
        txtdateE = datevalue[1];
      }
    }

    setIsLoadProgress(true);
    BindList(true , txtname , ddlstatus , txtdateS , txtdateE , txtmaxstaff , function() {
      setIsLoadProgress(false);
    });

  }

  //#endregion


  return (
    <>
      <Helmet>
        <title>Company</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="text-center">
                    {" "}
                    <h1>
                      <i className="fas fa-store-alt" /> Company List
                    </h1>
                  </div>
                  <div className="search-icon float-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <i className="fas fa-filter" /> Filter
                    </button>
                  </div>
                </div>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
            <div className="row" id="accordion">
              <div className="col-md-10 offset-md-1">
                <div
                  className="collapse show"
                  id="collapseOne"
                  data-parent="#accordion"
                >
                  <div className="row m-0">
                    <div className="col-10">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">Name</label>
                        <input
                          id="txt_searchName"
                          type="search"
                          className="form-control"
                          placeholder="Search by Name  or ... "
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="form-group ">
                        <label className="text-small p-0 m-0">Status</label>
                        <Select
                          options={liststatus}
                          placeholder={ConfigETC.ddl_All}
                          isClearable={true}
                          menuPortalTarget={document.body}
                          onChange={(e) => setddl_searchstatus(e)}
                          value={ddl_searchstatus}
                          styles={customStylesSelect}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-lg-4 col-6">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">Date</label>
                        <div className="input-group">
                          <DateRangePickerComponent 
                            id="txt_SearchDate"
                            format='dd/MM/yyyy' 
                            presets={dataPresets}
                            strictMode={true}
                          >
                          </DateRangePickerComponent>      
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-2">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">max staff</label>
                        <div className="input-group">
                          <input
                            type="text"
                            id="txt_searchMaxStaff"
                            className="form-control form-control-sm float-right"
                            pattern="[0-9]*"
                            onInput={handleChangetxtMaxStaff} 
                            value={txt_searchmaxstaff}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-4">&nbsp;</div>
                    <div className="col-lg-4 col-4 text-center">
                      <div className="form-group m-0">
                        <div className="card-tools">
                          <button
                            type="button"
                            id="btn_Search"
                            className="btn btn-primary btn-sm"
                            onClick={onClickSearch}
                          >
                            <i className="fas fa-search" /> Search
                          </button>
                          {" "}
                          <button
                            type="button"
                            className="btn btn-default btn-sm"
                            onClick={onClickReset}
                          >
                            <i className="fas fa-times" /> reset
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}

        {isresult === true &&
        <>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="card shadow table-responsive p-0">
                    <div className="card-header ">
                      <h3 className="card-title">
                        Result <small> ({listdata.length} items)</small>
                      </h3>
                      <span className="text-right">
                        <Link
                          to={"../" + Pathurl.m_company_ae}
                          state={{ comid: Class_ETC_Encrypt('0'), act: ActAdd }}
                          className="btn btn-primary btn-sm float-right fix-at-top"
                        >
                          <i className="fa fa-plus" /> New Company
                        </Link>
                      </span>
                    </div>
                    <div className="card-body p-0">
                      <input type="hidden" id="hd_iddel"></input>
                      <TableContainer>
                        <Table
                          stickyHeader
                          aria-label="sticky table"
                          className="table table-head-fixed table-hover"
                          border={0}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ width: "3%" }}><b>#</b></TableCell>
                              <TableCell style={{ width: "25%" }}><b>Company Name</b></TableCell>
                              <TableCell style={{ width: "12%" }}><b>Company Code</b></TableCell>
                              <TableCell style={{ width: "9%" }}><b>Start day</b></TableCell>
                              <TableCell style={{ width: "20%" }}><b>Start-End Service</b></TableCell>
                              <TableCell style={{ width: "8%" }}><b>Max Staffs</b></TableCell>
                              <TableCell style={{ width: "9%" }}><b>Active Staffs</b></TableCell>
                              <TableCell style={{ width: "7%" }} ><b>Status</b></TableCell>
                              <TableCell style={{ width: "6%" }} />
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(listdata.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={9} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                              listdata
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                  .map((row) => (
                                  <TableRow  key={row.rowindex} >
                                    <TableCell>{row.rowindex}</TableCell>
                                    <TableCell>
                                      <div>{row.com_name}</div>
                                    </TableCell>
                                    <TableCell>
                                      <div>{row.com_code}</div>
                                    </TableCell>
                                    <TableCell>
                                      <div>
                                        {row.start_day}{" "}<sup>{(row.start_day === 1 ? "st" :
                                                              row.start_day === 2 ? "nd" :
                                                              row.start_day === 3 ? "rd" : "th"
                                                              )}
                                                      </sup>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div>
                                        {row.start_end_service}{" "}
                                        {row.service_day !== "" &&
                                          <>
                                            <span
                                              className={row.service_day_class}
                                              data-toggle="tooltip"
                                              title="Expires within"
                                            >
                                              {" "}
                                              {row.service_day}
                                            </span>
                                          </> 
                                        }
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div>
                                        {row.max_staff} <small>staffs</small>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div>
                                        {row.active_staff} <small>staffs</small>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div className={(row.com_status === 1 ? ConfigETC.Status_active : ConfigETC.Status_inactive)}>
                                        {(row.com_status === 1 ? ConfigETC.SwitchButton_active_text : ConfigETC.SwitchButton_inactive_text)}
                                      </div>
                                    </TableCell>
                                    <TableCell className="text-right align-top">
                                      <div className="btn-group btn-group-sm">
                                        <Link
                                          to={"../" + Pathurl.m_company_ae}
                                          state={{ comid: Class_ETC_Encrypt(row.com_id.toString()), act: ActEdit }}
                                          className="btn btn-primary"
                                          data-toggle="tooltip"
                                          title="Click for edit"
                                        >
                                          <i className="fas fa-pencil-alt " />
                                        </Link>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {listdata.length > 0 && (
                        <TablePagination
                          rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                          component="div"
                          count={listdata.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={PaginationActions}
                        />
                      )}

                    </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                </div>
              </div>
            </div>
          </section>
        </>
        }


        
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_company;
